import {Suspense} from 'react'
import {SidebarMergeWhenReadyButton} from './SidebarMergeWhenReadyButton'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {MergeStatusRow} from './MergeStatusRow'
import {useMergeStatusRows} from './use-merge-status-rows'
import {useValidatedMergeData} from './use-validated-merge-data'
import {SidebarSection} from '@github-ui/pull-requests/components/overview/SidebarSection'

export function OverviewMergeStatus() {
  return (
    <ErrorBoundary boundaryName="OverviewMergeStatus" fallback={null}>
      <Suspense fallback={null}>
        <OverviewMergeStatusGate />
      </Suspense>
    </ErrorBoundary>
  )
}

function OverviewMergeStatusGate() {
  const validatedMergeData = useValidatedMergeData()

  if (!validatedMergeData) return null

  return <OverviewMergeStatusContent />
}

function OverviewMergeStatusContent() {
  const rows = useMergeStatusRows()
  if (!rows) return null

  return (
    <SidebarSection title="Merge status">
      <div className="d-flex flex-column gap-2">
        {rows.length === 0 ? (
          <p className="mb-0 color-fg-muted text-small">No merge requirements currently blocking this pull request.</p>
        ) : (
          rows.map(row => <MergeStatusRow key={`${row.label}-${row.detail ?? ''}`} row={row} />)
        )}
        <SidebarMergeWhenReadyButton />
      </div>
    </SidebarSection>
  )
}
